import React, { Fragment, useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import Peer from "simple-peer";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import ToggleButton from "../PlayerButtons/ToggleButton";

import DiscussionInfoOverlay from "../layout/Innovators/DiscussionInfoOverlay";

const JoinPanelDiscussion = ({ auth: { user, isAuthenticated } }) => {
  const ENDPOINT = "localhost:5000";

  const Video = () => {
    const ref = useRef();

    useEffect(() => {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then((stream) => {
          ref.current.srcObject = stream;
        })
        .catch((error) => {
          console.log(error);
        });
    }, []);

    if (!isAuthenticated) {
      return <Redirect to="/" />;
    } else if (isAuthenticated && user && user.channelid !== "roland") {
      return <Redirect to="/" />;
    }

    return (
      <div className="live-stream-video-container-alt">
        <div className="alt-video-overlay-dark">
          <div className="discuss-content">
            <div class="user-overlay-info">
              <div class="streamer-user-avi-md"></div>
              <div className="streamer-user-info">
                <p className="streamer-item bold">User Name</p>
                <i className="fas fa-ellipsis-v discussion-icon"></i>
                <div className="modal">
                  <ul className="modal-items">
                    <li className="modal-item">
                      <i className="fas fa-flag mx-5 white"></i>
                      Report
                    </li>
                    <li className="modal-item">
                      <i className="fas fa-ban mx-5 white"></i>
                      Block
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="video-stream-live green">
              <i className="fas fa-circle mx-5"></i>
              Live
            </div>
            <div className="alt-left-items">
              <ul className="discuss-items">
                <li className="discuss-item white">
                  <i className="fas fa-vote-yea fa-2x cursor"></i>
                </li>
                <li className="discuss-item discuss-font green">3,541</li>
              </ul>
            </div>
            <div className="alt-right-items">
              <ul className="discuss-items">
                <li className="discuss-item discuss-time green">:30</li>
                <li className="discuss-item-mute green">
                  <i className="fas fa-volume-mute fa-2x"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <video className="fill-video" playsInline autoPlay ref={ref}></video>
      </div>
    );
  };

  const [overlay, setoverlay] = useState(false);
  const playerRef = useRef(null);
  const [peers, setPeers] = useState([]);
  const socketRef = useRef();
  const userVideo = useRef();
  const peersRef = useRef([]);
  const roomID = "test";

  useEffect(() => {
    socketRef.current = io.connect(ENDPOINT);
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then((stream) => {
        userVideo.current.srcObject = stream;
        socketRef.current.emit("join room", roomID);
        socketRef.current.on("all users", (users) => {
          const peers = [];
          users.forEach((userID) => {
            const peer = createPeer(userID, socketRef.current.id, stream);
            peersRef.current.push({
              peerID: userID,
              peer,
            });
            peers.push(peer);
          });
          setPeers(peers);
        });

        socketRef.current.on("user joined", (payload) => {
          const peer = addPeer(payload.signal, payload.callerID, stream);
          peersRef.current.push({
            peerID: payload.callerID,
            peer,
          });

          const peerObj = {
            peer,
            peerID: payload.callerID,
          };

          setPeers((users) => [...users, peerObj]);
        });

        socketRef.current.on("receiving returned signal", (payload) => {
          const item = peersRef.current.find((p) => p.peerID === payload.id);
          item.peer.signal(payload.signal);
        });

        socketRef.current.on("user left", (id) => {
          const peerObj = peersRef.current.find((p) => p.peerId === id);
          if (peerObj) {
            peerObj.peer.destroy();
          }

          const peers = peersRef.current.filter((p) => p.peerID !== id);
          peersRef.current = peers;
          setPeers(peers);
        });
      })
      .catch((err) => {
        console.log(`An error occurred! ${err}`);
      });
  }, []);

  function createPeer(userToSignal, callerID, stream) {
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream,
    });

    peer.on("signal", (signal) => {
      socketRef.current.emit("sending signal", {
        userToSignal,
        callerID,
        signal,
      });
    });

    return peer;
  }

  function addPeer(incomingSignal, callerID, stream) {
    const peer = new Peer({
      initiator: false,
      trickle: false,
      stream,
    });

    peer.on("signal", (signal) => {
      socketRef.current.emit("returning signal", { signal, callerID });
    });

    peer.signal(incomingSignal);

    return peer;
  }

  console.log(peers);

  return (
    <Fragment>
      {overlay && <DiscussionInfoOverlay setoverlay={setoverlay} />}
      <div className="video-discussion-panel" ref={playerRef}>
        <div className="discussion-video-overlay">
          <ToggleButton
            className="Rac__screen-toggle"
            initial={document.fullscreenElement}
            onChange={(active) => {
              if (!active && KeyboardEvent.key === "Escape") {
                return document.exitFullscreen();
              }

              return playerRef.current.requestFullscreen({
                navigationUI: "hide",
              });
            }}
          >
            {(active) => {
              if (!active) {
                return (
                  <div className="watch-stream-alt">
                    <button className="watch-stream-button background-green">
                      <i className="fas fa-expand mx-5"></i>
                      Full Screen
                    </button>
                  </div>
                );
              }

              if (active) {
                return (
                  <div className="watch-stream">
                    <button className="watch-stream-button background-green">
                      <i className="far fa-keyboard mx-5"></i>
                      Esc to Exit
                    </button>
                  </div>
                );
              }
            }}
          </ToggleButton>
        </div>
        <div className="panel">
          <div className="live-stream-video-container-alt">
            <div className="alt-video-overlay-light">
              <div className="discuss-content">
                <div class="user-overlay-info">
                  <div class="streamer-user-avi-md"></div>
                  <div className="streamer-user-info">
                    <p className="streamer-item bold">User Name</p>
                    <i className="fas fa-ellipsis-v discussion-icon"></i>
                    <div className="modal">
                      <ul className="modal-items">
                        <li className="modal-item">
                          <i className="fas fa-flag mx-5 white"></i>
                          Report
                        </li>
                        <li className="modal-item">
                          <i className="fas fa-ban mx-5 white"></i>
                          Block
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="video-stream-live green">
                  <i className="fas fa-circle mx-5"></i>
                  Live
                </div>
                <div className="alt-left-items">
                  <ul className="discuss-items">
                    <li className="discuss-item white">
                      <i className="fas fa-vote-yea fa-2x cursor"></i>
                    </li>
                    <li className="discuss-item discuss-font green">3,541</li>
                  </ul>
                </div>
                <div className="alt-right-items">
                  <ul className="discuss-items">
                    <li className="discuss-item discuss-time green">:30</li>
                    <li className="discuss-item-mute green">
                      <i className="fas fa-volume-mute fa-2x"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <video
              className="fill-video"
              muted
              ref={userVideo}
              autoPlay
            ></video>
          </div>
          {peers.map((peer) => {
            return (
              <Video
                className="fill-video"
                autoplay
                key={peer.peerID}
                peer={peer.peer}
              />
            );
          })}
        </div>
        {/* <div className="panel">
          <div className="live-stream-video-container-alt">
            <div className="alt-video-overlay-dark">
              <div className="discuss-content">
                <div class="user-overlay-info">
                  <div class="streamer-user-avi-md"></div>
                  <div className="streamer-user-info">
                    <p className="streamer-item bold">User Name</p>
                    <i className="fas fa-ellipsis-v discussion-icon"></i>
                    <div className="modal">
                      <ul className="modal-items">
                        <li className="modal-item">
                          <i className="fas fa-flag mx-5 white"></i>
                          Report
                        </li>
                        <li className="modal-item">
                          <i className="fas fa-ban mx-5 white"></i>
                          Block
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="video-stream-live green">
                  <i className="fas fa-circle mx-5"></i>
                  Live
                </div>
                <div className="alt-left-items">
                  <ul className="discuss-items">
                    <li className="discuss-item white">
                      <i className="fas fa-vote-yea fa-2x cursor"></i>
                    </li>
                    <li className="discuss-item discuss-font green">3,541</li>
                  </ul>
                </div>
                <div className="alt-right-items">
                  <ul className="discuss-items">
                    <li className="discuss-item discuss-time green">:30</li>
                    <li className="discuss-item-mute green ">
                      <i className="fas fa-volume-mute fa-2x"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <video src={LiveStream} className="fill-video"></video>
          </div>
          <div className="live-stream-video-container-alt">
            <div className="alt-video-overlay-dark">
              <div className="discuss-content">
                <div class="user-overlay-info">
                  <div class="streamer-user-avi-md"></div>
                  <div className="streamer-user-info">
                    <p className="streamer-item bold">User Name</p>
                    <i className="fas fa-ellipsis-v discussion-icon"></i>
                    <div className="modal">
                      <ul className="modal-items">
                        <li className="modal-item">
                          <i className="fas fa-flag mx-5 white"></i>
                          Report
                        </li>
                        <li className="modal-item">
                          <i className="fas fa-ban mx-5 white"></i>
                          Block
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="video-stream-live green">
                  <i className="fas fa-circle mx-5"></i>
                  Live
                </div>
                <div className="alt-left-items">
                  <ul className="discuss-items">
                    <li className="discuss-item white">
                      <i className="fas fa-vote-yea fa-2x cursor"></i>
                    </li>
                    <li className="discuss-item discuss-font green">3,541</li>
                  </ul>
                </div>
                <div className="alt-right-items">
                  <ul className="discuss-items">
                    <li className="discuss-item discuss-time green">:30</li>
                    <li className="discuss-item-mute green">
                      <i className="fas fa-volume-mute fa-2x"></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <video src={LiveStream} className="fill-video"></video>
          </div>
        </div> */}
      </div>
      <div className="discussion-controls">
        <div class="discussion-icon-alt">
          <div class="action-button green" onClick={(e) => setoverlay(true)}>
            <i class="fas fa-info action-icon fa-lg"></i>
          </div>
          <p class="action-text">Discussion Info</p>
        </div>
        <div class="discussion-icon-alt">
          <div class="action-button green">
            <i class="fas fa-volume-mute action-icon fa-lg"></i>
          </div>
          <p class="action-text">Muted</p>
        </div>
        <div
          onClick={() => {
            navigator.mediaDevices.getUserMedia({ video: true });
          }}
          class="discussion-icon-alt"
        >
          <div class="action-button green">
            <i class="fas fa-video-slash action-icon-video-off fa-lg"></i>
          </div>
          <p class="action-text">Camera Off</p>
        </div>
        <div class="discussion-icon-alt">
          <div class="action-button white">
            <i class="fas fa-flag action-icon fa-lg"></i>
          </div>
          <p class="action-text">Leave Discussion</p>
        </div>
        <div class="discussion-icon-alt">
          <div class="action-button green">
            <i class="fas fa-user action-icon fa-lg"></i>
          </div>
          <p class="action-text">17,291</p>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {})(JoinPanelDiscussion);
